import { createSelector } from "reselect";

import Store, { RootState } from "../../../redux/store";
import {
  ExecutionBriefsState,
  TExecutionBriefResults,
} from "../../../redux/reducers/executionBriefsReducer";

import { IDuplicateExecutionBriefForm } from "../types/duplicate-execution-brief-form.interface";

import * as actions from "./execution-brief.actions";

export const getExecutionBriefState = (state: RootState) => state.executionBriefs;

export const getExecutionBrief = createSelector(
  getExecutionBriefState,
  (state: ExecutionBriefsState) => state.data
);

export const getExecutionBriefId = createSelector(
  getExecutionBrief,
  (brief: TExecutionBriefResults) => brief.id
);

export function duplicate(form: IDuplicateExecutionBriefForm) {
  Store.dispatch(actions.duplicate(form));
}
